import type {
  PblConsultationMethod,
  PblPrimaryLegalServiceNeed,
  PblServiceArea,
  PblVettingStatus,
} from '@/types/pbl';

export const pblServiceAreas: Array<{ value: PblServiceArea; defaultLabel: string; labelKey: string }> = [
  {
    value: 'estate_planning',
    defaultLabel: 'Estate Planning (Will/EPA/Advance Medical Directive)',
    labelKey: 'pbl.serviceArea.estatePlanning',
  },
  {
    value: 'family_matters',
    defaultLabel: 'Family Matters (Divorce/Maintenance/Custody/Inheritance)',
    labelKey: 'pbl.serviceArea.familyMatters',
  },
  {
    value: 'employment_disputes',
    defaultLabel: 'Employment Disputes',
    labelKey: 'pbl.serviceArea.employmentDisputes',
  },
  {
    value: 'building_management',
    defaultLabel: 'Building Management (Water Seepage/Property Management)',
    labelKey: 'pbl.serviceArea.buildingManagement',
  },
  {
    value: 'tenancy_and_properties',
    defaultLabel: 'Tenancy and properties related Matters',
    labelKey: 'pbl.serviceArea.tenancyAndProperties',
  },
  {
    value: 'criminal_matters',
    defaultLabel: 'Criminal Matters',
    labelKey: 'pbl.serviceArea.criminalMatters',
  },
];

export const pblLanguages = [
  { value: 'english', defaultLabel: 'English', labelKey: 'pbl.language.english' },
  { value: 'cantonese', defaultLabel: 'Cantonese', labelKey: 'pbl.language.cantonese' },
  { value: 'mandarin', defaultLabel: 'Mandarin', labelKey: 'pbl.language.mandarin' },
  { value: 'other', defaultLabel: 'Other', labelKey: 'pbl.language.other' },
] as const;

export const pblLawFirmPositions = [
  { value: 'partner', defaultLabel: 'Partner', labelKey: 'pbl.position.partner' },
  { value: 'consultant', defaultLabel: 'Consultant', labelKey: 'pbl.position.consultant' },
  { value: 'associate', defaultLabel: 'Associate', labelKey: 'pbl.position.associate' },
  { value: 'other', defaultLabel: 'Other', labelKey: 'pbl.position.other' },
] as const;

export const pblProfessionalQualifications = [
  { value: 'qualified_prc_lawyer', defaultLabel: 'Qualified PRC Lawyer', labelKey: 'pbl.qualification.prc' },
  { value: 'qualified_gba_lawyer', defaultLabel: 'Qualified GBA Lawyer', labelKey: 'pbl.qualification.gba' },
  {
    value: 'qualified_lawyer_overseas_jurisdictions',
    defaultLabel: 'Qualified lawyer in overseas jurisdictions',
    labelKey: 'pbl.qualification.overseas',
  },
  { value: 'not_applicable', defaultLabel: 'Not applicable', labelKey: 'pbl.qualification.notApplicable' },
  { value: 'other', defaultLabel: 'Other', labelKey: 'pbl.qualification.other' },
] as const;

export const pblLegalServiceNeeds: Array<{
  value: PblPrimaryLegalServiceNeed;
  defaultLabel: string;
  labelKey: string;
}> = [
    { value: 'oral_legal_advice', defaultLabel: 'Oral legal advice', labelKey: 'pbl.legalNeed.oralAdvice' },
    { value: 'document_review', defaultLabel: 'Document review', labelKey: 'pbl.legalNeed.documentReview' },
    { value: 'document_drafting', defaultLabel: 'Document drafting', labelKey: 'pbl.legalNeed.documentDrafting' },
    {
      value: 'legal_provision_explanation',
      defaultLabel: 'Legal provision explanation',
      labelKey: 'pbl.legalNeed.legalProvisionExplanation',
    },
    { value: 'other', defaultLabel: 'Other', labelKey: 'pbl.legalNeed.other' },
  ];

export const pblConsultationMethods: Array<{
  value: PblConsultationMethod;
  defaultLabel: string;
  labelKey: string;
}> = [
    { value: 'video_call', defaultLabel: 'Video call', labelKey: 'pbl.consultation.videoCall' },
  ];

export const pblVettingStatusLabels: Record<PblVettingStatus, string> = {
  pending_review: 'Pending',
  approved: 'Approved',
  resubmit_required: 'Under Re-Submission',
  rejected: 'Rejected',
  inactive: 'Inactive',
  withdrawn: 'Withdrawn',
};

export const pblDecisionReasons = [
  'Incomplete information',
  'Invalid / missing Authorization letter',
  'CV not provided in required format',
  'Service area experience unclear',
  'Identity / practising status requires clarification',
  'Other',
];
